import { render, staticRenderFns } from "./regional-cpf-modal.vue?vue&type=template&id=46c63c90"
import script from "./regional-cpf-modal.vue?vue&type=script&lang=js"
export * from "./regional-cpf-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports